import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { handlePasswordReset, openEmailLoginDialog } from "../auth/AuthActions";

const ResetPasswordDialog = ({ email, setEmail, onSubmit }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="space-y-4 py-2">
      <p className="text-sm text-gray-600">
        Enter the email address linked to your AIRCHECK account and we&apos;ll send you a secure link to reset your password.
      </p>
      <div className="flex flex-col gap-1">
        <label htmlFor="email" className="text-sm font-medium text-gray-700">
          Email address
        </label>
        <InputText
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="you@example.com"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );
};

const ResetPasswordDialogFooter = ({
  email,
  resetPassword,
  setNotificationMessage,
  setIsError,
  setShowNotification,
  setShowLoginDialog,
  setShowResetPasswordDialog,
  setShowLoginChoiceDialog,
  setShowSignUpDialog,
}) => {
  const submit = () =>
    handlePasswordReset(
      email,
      resetPassword,
      setNotificationMessage,
      setIsError,
      setShowNotification,
      setShowLoginDialog,
      setShowResetPasswordDialog,
    );

  return (
    <div className="flex justify-end gap-2 pt-2">
      <Button
        label="Back to Sign In"
        onClick={() =>
          openEmailLoginDialog(
            setShowLoginChoiceDialog,
            setShowSignUpDialog,
            setShowLoginDialog,
            setShowResetPasswordDialog,
          )
        }
        className="rounded-md shadow-sm px-5 py-2 bg-red-500 text-white hover:bg-red-700 transition duration-200"
      />
      <Button
        label="Send Reset Link"
        onClick={submit}
        className="rounded-md shadow-sm px-5 py-2 bg-green-500 text-white hover:bg-green-700 transition duration-200"
      />
    </div>
  );
};

export { ResetPasswordDialog, ResetPasswordDialogFooter };
